import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api from 'src/services/api'
import {GetBrainBoxParams} from 'src/services/api/endpoints/BrainBoxEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  params?: GetBrainBoxParams
  onError?: (error: unknown) => void
  enabled?: boolean
}

export default function useBrainBoxes({params = {}, onError, enabled = true}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.BRAIN_BOXES, params],
    queryFn: async () => (await api.brainBox.getAll(params)).data.data,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
